import { apiClient } from "../client";
import { StandardAxiosConfig } from "../common";
import { AgrianType } from "@domain/CRM/company";
import { AgrianTypes } from "@domain/Integrations/Agrian";
import { env } from "../../config/env";
export class AgrianAPI {
	private baseUrl: string;

	constructor() {
		this.baseUrl = `${env.rogoApiUrl}/agrian`;
	}

	private withFreshFlag(url: string, forceRefresh?: boolean): string {
		return forceRefresh ? `${url}&force_refresh=true` : url;
	}

	public async getOrganizations(type: AgrianType, forceRefresh = false): Promise<AgrianTypes.Organization[]> {
		const url = this.withFreshFlag(`${this.baseUrl}/organizations?type=${type}`, forceRefresh);
		const response = await apiClient.get(url, StandardAxiosConfig());
		return response.data as AgrianTypes.Organization[];
	}

	public async getOrganizationsByIds(
		ids: string[],
		type: AgrianType,
		forceRefresh = false,
	): Promise<AgrianTypes.Organization[]> {
		const url = this.withFreshFlag(`${this.baseUrl}/organizations?type=${type}`, forceRefresh);
		const response = await apiClient.post(url, ids, StandardAxiosConfig());
		return response.data as AgrianTypes.Organization[];
	}

	public async getGrowers(orgIds: string[], type: AgrianType, forceRefresh = false): Promise<AgrianTypes.Grower[]> {
		const url = this.withFreshFlag(`${this.baseUrl}/growers?type=${type}`, forceRefresh);
		const response = await apiClient.post(url, orgIds, StandardAxiosConfig());
		return response.data as AgrianTypes.Grower[];
	}

	public async getFarms(growerIds: string[], type: AgrianType, forceRefresh = false): Promise<AgrianTypes.Farm[]> {
		const url = this.withFreshFlag(`${this.baseUrl}/farms?type=${type}`, forceRefresh);
		const response = await apiClient.post(url, growerIds, StandardAxiosConfig());
		return response.data as AgrianTypes.Farm[];
	}

	public async getFields(farmIds: string[], type: AgrianType, forceRefresh = false): Promise<AgrianTypes.Field[]> {
		const url = this.withFreshFlag(`${this.baseUrl}/fields?type=${type}`, forceRefresh);
		const response = await apiClient.post(url, farmIds, StandardAxiosConfig());
		return response.data as AgrianTypes.Field[];
	}

	public async getSampleEvents(
		fieldIds: string[],
		type: AgrianType,
		forceRefresh = false,
	): Promise<AgrianTypes.HydratedSampleEvent[]> {
		const url = this.withFreshFlag(`${this.baseUrl}/sample-events?type=${type}`, forceRefresh);
		const response = await apiClient.post(url, fieldIds, StandardAxiosConfig());
		return response.data as AgrianTypes.HydratedSampleEvent[];
	}

	public async getTargetEvents(
		fieldIds: string[],
		type: AgrianType,
		forceRefresh = false,
	): Promise<AgrianTypes.HydratedTargetEvent[]> {
		const url = this.withFreshFlag(`${this.baseUrl}/target-events?type=${type}`, forceRefresh);
		const response = await apiClient.post(url, fieldIds, StandardAxiosConfig());
		return response.data as AgrianTypes.HydratedTargetEvent[];
	}

	public async getZones(
		fieldIds: string[],
		type: AgrianType,
		forceRefresh = false,
	): Promise<AgrianTypes.HydratedZone[]> {
		const url = this.withFreshFlag(`${this.baseUrl}/zones?type=${type}`, forceRefresh);
		const response = await apiClient.post(url, fieldIds, StandardAxiosConfig());
		return response.data as AgrianTypes.HydratedZone[];
	}

	public async getLabs(type: AgrianType, forceRefresh = false): Promise<AgrianTypes.Lab[]> {
		const url = this.withFreshFlag(`${this.baseUrl}/labs?type=${type}`, forceRefresh);
		const response = await apiClient.post(url, undefined, StandardAxiosConfig());
		return response.data as AgrianTypes.Lab[];
	}

	public async getLabPackages(
		labIds: string[],
		type: AgrianType,
		forceRefresh = false,
	): Promise<AgrianTypes.LabPackage[]> {
		const url = this.withFreshFlag(`${this.baseUrl}/lab-packages?type=${type}`, forceRefresh);
		const response = await apiClient.post(url, labIds, StandardAxiosConfig());
		return response.data as AgrianTypes.LabPackage[];
	}
}
